import { render } from "./ass_entusrNew.vue?vue&type=template&id=8f283e8e"
import script from "./ass_entusrNew.vue?vue&type=script&lang=js"
export * from "./ass_entusrNew.vue?vue&type=script&lang=js"

import "./css/ass_entusrNew.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__